export default __webpack_public_path__ + "a4aeb4f175db17483d21960651e14d2b.jpg";